import type { components } from '@/lib/api/generated/schema'
import { api } from '@/lib/api'

export type EInvoiceCredential = components['schemas']['MyEInvoiceCredential']
export type VerifyEInvoiceCredentialRequest =
    components['schemas']['VerifyMyEInvoiceCredentialRequest']

export const einvoiceCredentialApi = {
    get: () => api.get<EInvoiceCredential>('/einvoices/my-credential'),
    verify: (data: VerifyEInvoiceCredentialRequest) =>
        api.post<EInvoiceCredential>('/einvoices/my-credential/verify', data),
    remove: () => api.delete<void>('/einvoices/my-credential'),
}
